export enum OrderConfirmableAction {
  REFUND = 'REFUND',
  RESET = 'RESET',
  RESEND = 'RESEND'
}

export type OrderConfirmableActionType = OrderConfirmableAction.REFUND | OrderConfirmableAction.RESET | OrderConfirmableAction.RESEND;

// Modal content for order actions that require confirmation
export const ORDER_CONFIRMABLE_ACTION_COPY = {
  [OrderConfirmableAction.REFUND]: {
    title: 'Refund order',
    description: 'Are you sure you want to refund this order? This action cannot be undone.',
    actionText: 'Refund'
  },
  [OrderConfirmableAction.RESET]: {
    title: 'Reset order',
    description: 'Are you sure you want to reset this order? This action cannot be undone.',
    actionText: 'Reset'
  },
  [OrderConfirmableAction.RESEND]: {
    title: 'Resend order',
    description: 'Are you sure you want to resend this order?',
    actionText: 'Resend'
  }
} as const;
